/* ==========================================================================
   assets/announcement-bar.js
   Pauses the mobile marquee the moment a user touches/clicks/drags
   it, handing control over to the viewport's native overflow-x:auto
   scrolling instead of fighting the CSS animation. Deliberately does
   NOT auto-resume — resuming mid-scroll would yank the content out
   from under the user's finger, which is worse than just staying
   paused until they navigate away.
   ========================================================================== */
(function () {
  'use strict';

  function pauseTrack(viewport) {
    var track = viewport.querySelector('[data-announcement-track]');
    if (track) track.classList.add('is-paused');
  }

  document.addEventListener('pointerdown', function (e) {
    var viewport = e.target.closest('[data-announcement-viewport]');
    if (viewport) pauseTrack(viewport);
  });

  // Fallback for browsers without pointer events
  document.addEventListener('touchstart', function (e) {
    var viewport = e.target.closest('[data-announcement-viewport]');
    if (viewport) pauseTrack(viewport);
  }, { passive: true });
})();
